/**
 * API with a similar signature to our MX api
 *
 * @param {Object} Events
 * @param {Object} Analytics
 * @return function
 */
export function buildAPI(Events, Analytics) {
  return function API(target, eventSignature, callback) {
    switch (target) {
      case 'event:listen':
        if (eventSignature === '*') {
          // See https://backbonejs.org/#Events-on for order of params
          const swapParams = function (eventName, params) {
            callback(params, eventName);
          };
          Events.on('all', swapParams);
          return Events.off.bind(Events, 'all', swapParams);
        } else {
          Events.on(eventSignature, callback);
          return Events.off.bind(Events, eventSignature, callback);
        }
      case 'analytics:listen':
        return Analytics.on(eventSignature, callback);
      case 'analytics:listen:cold':
        return Analytics.cold(eventSignature, callback);
      // TODO: Add support for other API targets here if they need to be supported
      default:
        console.warn('Unsupported API method: ' + target);
    }
  };
}
